// extracted by mini-css-extract-plugin
module.exports = {"data":"styles_data__6JurB","data-type":"styles_data-type__1WOrt","value":"styles_value__1dWYr"};